'use strict';

var React = require('react');

var SvgCircleUpMajor = function SvgCircleUpMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm1 8.414 1.293 1.293a1 1 0 1 0 1.414-1.414l-3-3a.998.998 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414l1.293-1.293v5.586a1 1 0 1 0 2 0v-5.586z"
  }));
};

exports.SvgCircleUpMajor = SvgCircleUpMajor;
